import * as React from 'react';
import { Link } from 'react-router-dom';

import { RightArrow } from '../assets/RightArrow';

export const ProductPricingNutrientInfo = () => {
  return (
    <div className="p-10 bg-slate-50 min-h-[100vh]">
      <h1>Product, Pricing, Nutrient Info</h1>
      <Link
        className="flex flex-row items-center justify-between w-3/5 text-xl py-4 px-8 bg-white text-black border border-black mt-4"
        to="/product-pricing-nutrient-info/unKibble"
      >
        <div className="flex flex-col items-start">
          <span className="font-bold py-2">Product & Pricing Info - UnKibble</span>
          <span className="text-sm py-2">
            View product and pricing information for UnKibble products
          </span>
        </div>
        <RightArrow className="w-6 h-6" />
      </Link>
      <Link
        className="flex flex-row items-center justify-between w-3/5 text-xl py-4 px-8 bg-white text-black border border-black mt-4"
        to="/product-pricing-nutrient-info/fresh"
      >
        <div className="flex flex-col items-start">
          <span className="font-bold py-2">Product & Pricing Info - Fresh</span>
          <span className="text-sm py-2">
            View product and pricing information for Fresh products
          </span>
        </div>
        <RightArrow className="w-6 h-6" />
      </Link>
      <Link
        className="flex flex-row items-center justify-between w-3/5 text-xl py-4 px-8 bg-white text-black border border-black mt-4"
        to="/product-pricing-nutrient-info/ancillary"
      >
        <div className="flex flex-col items-start">
          <span className="font-bold py-2">Product & Pricing Info - Ancillary</span>
          <span className="text-sm py-2">
            View product and pricing information for Ancillary products
          </span>
        </div>
        <RightArrow className="w-6 h-6" />
      </Link>
      <Link
        className="flex flex-row items-center justify-between w-3/5 text-xl py-4 px-8 bg-white text-black border border-black mt-4"
        to="/product-pricing-nutrient-info/nutrient-analysis"
      >
        <div className="flex flex-col items-start">
          <span className="font-bold py-2">Nutrient Analysis</span>
          <span className="text-sm py-2">
            View nutrient analysis information for UnKibble and Fresh recipes
          </span>
        </div>
        <RightArrow className="w-6 h-6" />
      </Link>
    </div>
  );
};
